import React from "react";
import { formatDistanceToNow } from "date-fns";
import { ChatMessage } from "@/types/chat";
import { useAuthStore } from "@/store/authStore";
import { Trash2 } from "lucide-react";
import { cn } from "@/lib/currencyFormatter";

interface DeletedMessageBubbleProps {
  message: ChatMessage;
}

export const DeletedMessageBubble: React.FC<DeletedMessageBubbleProps> = ({
  message,
}) => {
  const { user } = useAuthStore();
  const isCurrentUser = user?.id === message.sender_id;

  return (
    <div
      className={cn(
        "flex mb-3",
        isCurrentUser ? "justify-end" : "justify-start"
      )}
    >
      <div
        className={cn(
          "max-w-[80%] relative rounded-lg px-4 py-2 shadow bg-muted text-muted-foreground",
          isCurrentUser ? "rounded-br-none" : "rounded-bl-none"
        )}
      >
        {!isCurrentUser && (
          <div className="font-semibold text-xs mb-1">
            {message.sender_name}
          </div>
        )}

        <div className="italic text-sm flex items-center">
          <Trash2 className="h-3.5 w-3.5 mr-1" />
          This message was deleted
        </div>

        <div className="text-xs opacity-70 mt-1">
          {formatDistanceToNow(new Date(message.created_at), {
            addSuffix: true,
          })}
        </div>
      </div>
    </div>
  );
};
